export default __webpack_public_path__ + "static/media/766.50cd0240.png";